import React from 'react'
import { cva, VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

import { Badge, badgeVariants } from '@/components/ui'

const qtyBadgeVariants = cva('flex items-center gap-2', {
  variants: {
    size: {
      default: 'text-sm',
      md: 'text-[11px]',
      lg: 'text-base',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})

interface QtyBadgeProps
  extends React.ComponentPropsWithoutRef<'div'>,
    VariantProps<typeof qtyBadgeVariants> {
  badge?: VariantProps<typeof badgeVariants> &
    React.ComponentPropsWithoutRef<'div'>
}

export const QtyBadge = ({
  children,
  badge,
  size,
  className,
}: QtyBadgeProps) => {
  const {
    children: badgeChildren,
    className: badgeClassName,
    ...restBadge
  } = badge ?? {}
  return (
    <div className={cn(qtyBadgeVariants({ size, className }))}>
      <Badge
        className={cn('w-[28px]', badgeClassName)}
        size={size}
        variant="outline"
        {...restBadge}
      >
        {badgeChildren ?? 'QTY'}
      </Badge>
      <span className={cn('font-mono font-medium leading-[1.2]')}>
        {children}
      </span>
    </div>
  )
}
